var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 509.421 509.421",
    style: {
      enableBackground: "new 0 0 509.421 509.421"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC9FF"
    },
    d: "M409.421,251.348V123.073c-35.366,0-64.139,28.772-64.139,64.138S374.055,251.348,409.421,251.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57A4FF"
    },
    d: "M473.56,187.211c0-35.366-28.772-64.138-64.139-64.138v128.275 C444.788,251.348,473.56,222.576,473.56,187.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC9FF"
    },
    d: "M509.421,366.348c0-55.14-44.859-100-100-100c-28.619,0-55.206,12.071-73.879,32.602 c26.098,21.11,43.814,52.191,47.288,87.398h126.591V366.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC9FF"
    },
    d: "M173.879,298.95c-18.673-20.53-45.26-32.602-73.879-32.602c-55.14,0-100,44.86-100,100v20h126.59 C130.065,351.141,147.781,320.06,173.879,298.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC9FF"
    },
    d: "M100,251.348V123.073c-35.366,0-64.138,28.772-64.138,64.138S64.634,251.348,100,251.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57A4FF"
    },
    d: "M164.138,187.211c0-35.366-28.772-64.138-64.138-64.138v128.275 C135.366,251.348,164.138,222.576,164.138,187.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003F8A"
    },
    d: "M335.542,298.95c-22.114-17.888-50.242-28.619-80.832-28.619v148.76h128.75v-20 c0-4.3-0.216-8.55-0.63-12.742C379.356,351.141,361.64,320.06,335.542,298.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003F8A"
    },
    d: "M334.71,170.331c0-44.11-35.89-80-80-80v160C298.82,250.331,334.71,214.451,334.71,170.331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005ECE"
    },
    d: "M173.879,298.95c-26.098,21.11-43.814,52.191-47.289,87.398c-0.414,4.193-0.63,8.443-0.63,12.742v20 h128.75v-148.76C224.121,270.331,195.993,281.062,173.879,298.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005ECE"
    },
    d: "M254.71,250.331v-160c-44.11,0-80,35.89-80,80C174.71,214.451,210.6,250.331,254.71,250.331z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.a192176ecdcd657c5fa342706a91dc57.svg";
export { ForwardRef as ReactComponent };